import type { EntityService } from '@/utils/api/maintenance/api';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useServiceStore = defineStore(
  'service',
  () => {
    /** サービス一覧 */
    const services = ref<EntityService[]>([]);

    /** IDからサービスを取得する */
    const getService = (serviceId?: number) => {
      return services.value.find((v) => v.serviceId === serviceId);
    };

    /** サービス一覧を更新する */
    const updateServices = (value: EntityService[]): void => {
      services.value = value.sort((a, b) => {
        if (a.viewOrder && b.viewOrder) {
          return a.viewOrder - b.viewOrder;
        } else {
          return -1;
        }
      });
    };

    /**
     * storeの初期化
     */
    const clear = (): void => {
      services.value = [];
    };

    return {
      services,
      getService,
      updateServices,
      clear
    };
  },
  { persist: { storage: sessionStorage } }
);
